import Component, { mixins } from 'vue-class-component'

import WithRender from './DefaultLayout.html'

import { MErrorResourceUnavailable } from '@ulaval/modul-components'

import NavigationBar  from '@/modules/global/navigation-bar/NavigationBar'

@WithRender
@Component({
  components: {
    MErrorResourceUnavailable,
    NavigationBar
  }
})
export default class DefaultLayout extends mixins() {}
